import { createFileRoute, redirect } from "@tanstack/react-router"

import { LINKS } from "../../../../routing/links"

export const Route = createFileRoute("/$sessionId/_session/damage/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: LINKS.damageIntro(params.sessionId) })
  },
})
